import { lazy, Suspense } from "react";
import { ThemeProvider } from "@/components/ThemeProvider";
import { CookieBanner } from "@/components/CookieBanner";
import { HelpSystem } from "@/components/help/HelpSystem";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const Landing = lazy(() => import("./pages/Landing"));
const Index = lazy(() => import("./pages/Index"));
const Admin = lazy(() => import("./pages/Admin"));
const NotFound = lazy(() => import("./pages/NotFound"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const PublicJobs = lazy(() => import("./pages/PublicJobs"));
const Matchning = lazy(() => import("./pages/Matchning"));
const CareerCoach = lazy(() => import("./pages/CareerCoach"));
const Spanare = lazy(() => import("./pages/Spanare"));
const TrenderLanding = lazy(() => import("./pages/trender/TrenderLanding"));
const Marknadspulsen = lazy(() => import("./pages/trender/Marknadspulsen"));
const Sektorer = lazy(() => import("./pages/trender/Sektorer"));
const Loner = lazy(() => import("./pages/trender/Loner"));
const AISkills = lazy(() => import("./pages/trender/AISkills"));
const Jobbkartan = lazy(() => import("./pages/trender/Jobbkartan"));
const Unsubscribe = lazy(() => import("./pages/Unsubscribe"));
const EmployerDashboard = lazy(() => import("./pages/EmployerDashboard"));
const CompanyProfile = lazy(() => import("./pages/CompanyProfile"));
const Priser = lazy(() => import("./pages/Priser"));
const CheckoutReturn = lazy(() => import("./pages/CheckoutReturn"));

const queryClient = new QueryClient();

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/app" element={<Index />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/jobs" element={<PublicJobs />} />
              <Route path="/matchning" element={<Matchning />} />
              <Route path="/coach" element={<CareerCoach />} />
              <Route path="/spanare" element={<Spanare />} />
              <Route path="/trender" element={<TrenderLanding />} />
              <Route path="/trender/marknadspulsen" element={<Marknadspulsen />} />
              <Route path="/trender/sektorer" element={<Sektorer />} />
              <Route path="/trender/loner" element={<Loner />} />
              <Route path="/trender/ai" element={<AISkills />} />
              <Route path="/trender/karta" element={<Jobbkartan />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/arbetsgivare" element={<EmployerDashboard />} />
              <Route path="/foretag/:slug" element={<CompanyProfile />} />
              <Route path="/priser" element={<Priser />} />
              <Route path="/checkout/return" element={<CheckoutReturn />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <HelpSystem />
        </BrowserRouter>
        <CookieBanner />
      </TooltipProvider>
    </QueryClientProvider>
  </ThemeProvider>
);

export default App;
